import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ roles, children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="grid min-h-screen place-items-center bg-[#F5F7FA]" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-[#1E6FD9]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/crm/dashboard" replace />;
  return children;
};
